import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import VideoDemo from '@/components/feature/VideoDemo';
import Features from '@/components/feature/Features';
import PillarSections from '@/components/feature/PillarSections';
import Showcase from '@/components/feature/Showcase';
import Pricing from '@/components/feature/Pricing';
import CTA from '@/components/feature/CTA';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-surface">
      <Navbar />
      <main>
        {/* Positioning: the AI ad engine that lifts ROAS — research → create → publish.
            Section flow + copy locked in /homepage-message.md */}
        <Hero />
        <VideoDemo />         {/* "watch it work" — autoplay Fusion demo */}
        <Features />          {/* the engine in 4 steps */}
        <PillarSections />    {/* Ad Strategist · Fusion · Templates · AdPilot */}
        <Showcase />          {/* Results / ROAS proof */}
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
